/** Random H2H invite WhatsApp text, tone-matched to the daily share system. */

interface H2HTemplate {
  he: string;
  en: string;
}

const H2H_INVITE_TEMPLATES: H2HTemplate[] = [
  {
    he: "בוא נעשה דו-קרב ב-ניגונים\n{songCount} {songLabel}, תו אחד לכל סיבוב, מי שמזהה יותר מנצח\n{url}",
    en: "Let's do a Niggunim duel\n{songCount} {songLabel}, one note per round, whoever guesses more wins\n{url}",
  },
  {
    he: "אני מזמין אותך לדו-קרב בניגונים\n{songCount} {songLabel}, תו אחד לשיר — נראה מי יותר טוב\n{url}",
    en: "Challenging you to a Niggunim duel\n{songCount} {songLabel}, one note each — let's see who's better\n{url}",
  },
  {
    he: "דו-קרב ניגונים — אתה נגדי\n{songCount} {songLabel}, ניחוש מתו אחד, שנינו מקבלים אותם ניגונים\n{url}",
    en: "Niggunim duel — you vs me\n{songCount} {songLabel}, guess from one note, same niggunim for both of us\n{url}",
  },
  {
    he: "♪ דו-קרב ניגונים ♪\n{songCount} {songLabel}, תו אחד לכל סיבוב\nנראה מי מזהה מהר יותר\n{url}",
    en: "♪ Niggunim duel ♪\n{songCount} {songLabel}, one note per round\nSee who identifies quicker\n{url}",
  },
];

function songLabel(songCount: number, locale: "he" | "en"): string {
  if (locale === "he") {
    return songCount === 1 ? "ניגון" : "ניגונים";
  }
  return songCount === 1 ? "niggun" : "niggunim";
}

export function generateH2HInviteText(
  url: string,
  locale: "he" | "en" = "en",
  songCount: number = 3,
): string {
  const template = H2H_INVITE_TEMPLATES[Math.floor(Math.random() * H2H_INVITE_TEMPLATES.length)];
  const raw = locale === "he" ? template.he : template.en;
  return raw
    .replace(/\{songCount\}/g, String(songCount))
    .replace(/\{songLabel\}/g, songLabel(songCount, locale))
    .replace(/\{url\}/g, url);
}
